import { useApi } from "@/lib/api";
import { AdminTitle } from "./AdminUi";

const Stat = ({ label, value, testId }) => (
  <div className="card-soft !bg-white p-5" data-testid={testId}>
    <p className="text-sm text-ink-muted">{label}</p>
    <p className="mt-1 font-serif text-4xl">{value ?? "–"}</p>
  </div>
);

const TopList = ({ title, rows }) => (
  <div className="card-soft !bg-white p-5">
    <h2 className="text-lg font-semibold font-sans mb-3">{title}</h2>
    {rows.length === 0 ? <p className="text-sm text-ink-muted">No data yet.</p> : (
      <ul className="space-y-2 text-sm">{rows.map((r) => <li key={r.key} className="flex justify-between gap-3"><span className="truncate">{r.key}</span><span className="font-semibold">{r.count}</span></li>)}</ul>
    )}
  </div>
);

export default function AdminOverview() {
  const { data: d } = useApi("/admin/analytics?days=30");
  if (!d) return <p role="status">Loading…</p>;
  const max = Math.max(1, ...d.daily.map((x) => x.count));
  return (
    <div data-testid="admin-overview">
      <AdminTitle title="Overview">Aggregated, privacy-conscious usage for the last 30 days. No cookies, IP addresses or individual visitor data are stored.</AdminTitle>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        <Stat label="Page views" value={d.total_pageviews} testId="stat-pageviews" />
        <Stat label="Published articles" value={d.published_articles} testId="stat-published" />
        <Stat label="Draft articles" value={d.draft_articles} testId="stat-drafts" />
        <Stat label="Directory entries to verify" value={d.directory_needs_review} testId="stat-directory-review" />
        {d.new_enquiries !== null && <Stat label="New enquiries" value={d.new_enquiries} testId="stat-new-enquiries" />}
        {d.new_partnerships !== null && <Stat label="New partnership interest" value={d.new_partnerships} testId="stat-new-partnerships" />}
      </div>
      <div className="card-soft !bg-white p-5 mt-6">
        <h2 className="text-lg font-semibold font-sans mb-4">Daily page views</h2>
        <div className="flex items-end gap-1 h-40" aria-label="Daily page views chart">
          {d.daily.map((x) => <div key={x.date} title={`${x.date}: ${x.count}`} className="flex-1 bg-teal/80 rounded-t" style={{ height: `${(x.count / max) * 100}%` }} />)}
        </div>
      </div>
      <div className="grid gap-4 lg:grid-cols-2 xl:grid-cols-4 mt-6">
        <TopList title="Top pages" rows={d.top_pages} />
        <TopList title="Pathways chosen" rows={d.pathways} />
        <TopList title="Worksheets printed" rows={d.tools} />
        <TopList title="Guided journeys (counts only, no answers)" rows={d.journeys || []} />
      </div>
    </div>
  );
}
